// eslint-disable-next-line import/extensions
import DOMPurify from 'dompurify'

// Ensure target="_blank" links have rel="noopener noreferrer"
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (
    node.tagName === 'A' &&
    node.getAttribute('target')?.toLowerCase() === '_blank'
  ) {
    const existingRel = node.getAttribute('rel') || ''
    const relValues = new Set(existingRel.split(/\s+/).filter(Boolean))
    relValues.add('noopener')
    relValues.add('noreferrer')
    node.setAttribute('rel', Array.from(relValues).join(' '))
  }
})

const PURIFY_CONFIG = Object.freeze({
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li'],
  ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
  ALLOW_DATA_ATTR: false,
})

const sanitizeText = (text) => DOMPurify.sanitize(text, PURIFY_CONFIG)

// Recursively sanitizes all string values in a request body
const sanitizeRequestBody = (body) => {
  if (body == null) return body

  if (typeof body === 'string') {
    return sanitizeText(body)
  }

  if (Array.isArray(body)) {
    return body.map((item) => sanitizeRequestBody(item))
  }

  if (typeof body === 'object') {
    return Object.fromEntries(
      Object.entries(body).map(([key, value]) => [
        key,
        sanitizeRequestBody(value),
      ])
    )
  }

  return body
}

export { sanitizeText, sanitizeRequestBody }
